import { Color, PaletteColorOptions, PaletteOptions } from "@mui/material";

type CardPalette = {
  background1?: string;
  selectedBackground?: string;
  hover?:string;
  text1?: string;
  text2?: string;
  text3?: string;
  border?: string;
  shadow?: string;
};

type NavPalette = {
  background1?: string;
  background2?: string;
  text1?: string;
  text2?: string;
  text3?: string;
  shadow?: string;
  border1?: string;
  border2?: string;
};
declare module "@mui/material/styles" {
  interface Palette {
    courseCard?: { background1: string; text1: string; text2: string };
    adminProfCard: CardPalette;
    adminDashCard?: CardPalette;
    adminDashOverviewCard?: CardPalette;
    adminGraderUserCard?: CardPalette;
    adminCourseQuestionReviewCard?: CardPalette;
    adminNav?: NavPalette;
    adminNavItem?: NavPalette;
    qTab?: {
      background1: string;
      selectedBackground: string;
      text1: string;
      text2: string;
    };
    border?: {
      adminDashBorder?: string;
      adminGraderContainerBorder?: string;
      adminCourseQuestionReviewCardBorder?: string;
    };
  }
  interface PaletteOptions {
    purple?: Partial<Color> | { 450?: string; 350?: string } | undefined;
    log?:
      | PaletteColorOptions
      | { log1: string; log2: string; logForm: string }
      | undefined;
    courseCard?:
      | PaletteColorOptions
      | { background1: string; text1: string; text2: string }
      | undefined;
    qTab?: PaletteColorOptions | CardPalette | undefined;
    adminProfCard?: PaletteColorOptions | CardPalette | undefined;
    adminDashCard?: PaletteColorOptions | CardPalette | undefined;
    adminDashOverviewCard?: PaletteColorOptions | CardPalette | undefined;
    adminGraderUserCard?: PaletteColorOptions | CardPalette | undefined;
    adminCourseQuestionReviewCard?:
      | PaletteColorOptions
      | CardPalette
      | undefined;
    adminNav?: PaletteColorOptions | NavPalette | undefined;
    adminNavItem?: NavPalette;
    border?:
      | PaletteColorOptions
      | {
          adminDashBorder: string;
          adminGraderContainerBorder: string;
          adminCourseQuestionReviewCardBorder?: string;
        }
      | undefined;
  }
  interface TypeBackground {
    authBg?: string | undefined;
    base?: string | undefined;
    alternate?: string | undefined;
    courseCard?: string | undefined;
    qTab?: string | undefined;
    adminBg?: string | undefined;
    adminNavBg?: string | undefined;
    adminNavItemBg?: string | undefined;
    adminDashBg1?: string | undefined;
    adminTableRowBg1?: string | undefined;
    adminTableRowBg2?: string | undefined;
    adminDashBg1Inverted?: string | undefined;
    adminDashBorder?: string | undefined;
    adminCourseQuestionReviewCardBg?: string | undefined;
    adminGraderContainerBg?: string | undefined;
    adminCourseGraderQuestionReviewChipBg?: string | undefined;
    gradientBtn: string | undefined;
  }
}

export const lightThemePalette: PaletteOptions = {
  mode: "light",
  grey: {
    500: "#AFAFAF",
    400: "#AFAFAF",
    300: "#D9D9D9",
    200: "#868686",
    100: "#AFAFAF",
  },
  purple: {
    500: "#8D36D1",
    450: "#7A2DC7",
    400: "#8428c0",
    300: "#8D36D1",
    350: "#9840D2",
    200: "#d1adf5",
    100: "#8D36D1",
  },
  error: {
    500: "#bd380f",
    400: "#e24312",
    300: "#f1410b",
    200: "#d1adf5",
    100: "#FF4A13",
  },
  log: {
    log1: "#470871",
    log2: "#d70380",
    logForm: "#341548",
  },
  background: {
    default: "#fcfcfc",
    authBg: "var(--auth-linear-bg)",
    paper: "#fcfcfc",
    base: "white",
    alternate: "#f3f6fc",
    courseCard: "linear-gradient(100.99deg, #FFFFFF 0%, #A780FF 100%)",
    adminBg: "#E8DAFF",
    adminNavBg: "#FFF",
    adminNavItemBg: "linear-gradient(101deg, #FFF 0%, #A780FF 100%)",
    adminDashBg1: "linear-gradient(101deg, #EDE5FF 0%, #DBCBFF 100%)",
    adminCourseQuestionReviewCardBg:
      "linear-gradient(101deg, #FFF 0%, #DBCBFF 100%)",
    adminTableRowBg1: "inherit",
    adminTableRowBg2: "rgba(255, 255, 255, 0.42)",
    adminGraderContainerBg: "#E8DAFF",
    adminCourseGraderQuestionReviewChipBg: "#160126",
    gradientBtn:"linear-gradient(0deg, #823CDE 0%, #823CDE 100%)"
  },
  courseCard: {
    background1: "linear-gradient(100.99deg, #FFFFFF 0%, #A780FF 100%)",
    text1: "#8A33BB",
    text2: "linear-gradient(90.2deg, #8428C0 0.06%, #903DB7 62.24%)",
  },
  adminProfCard: {
    background1: "linear-gradient(0deg, #A780FF 0%, #A780FF 100%)",
    selectedBackground: "#0B1739",
    text1: "#FFFFFF",
    text2: "#000000",
    border: "#343B4F",
  },
  adminDashCard: {
    background1: "linear-gradient(-101deg, #EDE5FF 0%, #DBCBFF 100%)",
    text1: "#000",
    text2: "#7E89AC",
    text3: "#500909",
    border: "#919191",
    shadow: "1px 1px 1px 0px rgba(16, 25, 52, 0.40)",
  },
  adminDashOverviewCard: {
    background1: "linear-gradient(101deg, #EDE5FF 0%, #DBCBFF 100%)",
    text1: "#000",
    text2: "#453D3D",
    text3: "#000",
    border: "#919191",
    shadow: "1px 1px 1px 0px rgba(16, 25, 52, 0.40)",
  },
  adminGraderUserCard: {
    background1: "linear-gradient(101deg, #EDE5FF 0%, #DBCBFF 100%)",
    selectedBackground: "linear-gradient(0deg, #DBCBFF 0%, #DBCBFF 100%)",
    hover:"linear-gradient(0deg, #DBCBFF 0%, #DBCBFF 100%)",
    text1: "#463232",
    text2: "#878787",
    text3: "#414141",
  },
  qTab: {
    background1: "transparent",
    selectedBackground: "transparent",
    text1: "black",
    text2: "gray",
  },
  adminNav: {
    shadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    background1: "#E8DAFF",
    text1: "#100303",
    text2: "#5869A5",
  },
  adminNavItem: {
    background1:  "linear-gradient(0deg, rgba(117, 56, 255, 0.80) 0%, rgba(117, 56, 255, 0.80) 100%)",
    background2:
      "linear-gradient(0deg, rgba(167, 128, 255, 0.80) 0%, rgba(167, 128, 255, 0.80) 100%)",
    text1: "#FFF",
    text2: "#FFF",
    text3: "#FFF",
    border1: "#814AFF",
    border2: "#814AFF",
  },
  border: {
    adminDashBorder: "#e3eaff",
    adminGraderContainerBorder: "#ABABAD",
    adminCourseQuestionReviewCardBorder: "#ABABAD",
  },
};

export const darkThemePalette: PaletteOptions = {
  mode: "dark",
  grey: {
    500: "#AFAFAF",
    400: "#AFAFAF",
    300: "#D9D9D9",
    200: "#868686",
    100: "#AFAFAF",
  },
  purple: {
    500: "#8D36D1",
    450: "#7A2DC7",
    400: "#8428c0",
    300: "#8D36D1",
    350: "#9840D2",
    200: "#d1adf5",
    100: "#8D36D1",
  },
  error: {
    500: "#bd380f",
    400: "#e24312",
    300: "#f1410b",
    200: "#d1adf5",
    100: "#FF4A13",
  },
  background: {
    default: "#1f1f1f",
    authBg: "var(--auth-linear-bg)",
    courseCard: "linear-gradient(100.99deg, #523988 0%, #3C3265 100%)",
    adminBg: "linear-gradient(270deg, #5E5E9E -51.14%, #150025 39.58%)",
    adminNavBg: "#150025",
    adminNavItemBg: "#081028",
    adminDashBg1: "#0B1739",
    adminCourseQuestionReviewCardBg: "#0B1739",
    adminTableRowBg1: "inherit",
    adminTableRowBg2: "#0A1330",
    adminGraderContainerBg: "#0B1739",
    adminCourseGraderQuestionReviewChipBg: "#2f9ec138",
    gradientBtn:"linear-gradient(241.8deg, #C391E9 16.91%, #B06FDE 31.2%, #A064C9 45.49%, #955CBC 59.78%, #8B57B0 88.35%)"
  },
  courseCard: {
    background1: "linear-gradient(100.99deg, #523988 0%, #3C3265 100%)",
    text1: "#FFFFFF",
    text2: "linear-gradient(90.2deg, #F1DBFF 0.06%, #9A6CF5 62.24%)",
  },
  adminProfCard: {
    background1: "#0B1739",
    selectedBackground: "linear-gradient(101deg, #FFF 0%, #BA9CFF 100%)",
    text1: "#FFFFFF",
    text2: "#9A13F2",
    border: "#343B4F",
  },
  adminDashCard: {
    background1: "#0B1739",
    text1: "#FFF",
    text2: "#7E89AC",
    text3: "#D9E1FA",
    border: "#0B1739",
    shadow: "1px 1px 1px 0px rgba(16, 25, 52, 0.40)",
  },
  adminDashOverviewCard: {
    background1: "#0B1739",
    text1: "#FFF",
    text2: "#AEB9E1",
    text3: "#FFF",
    border: "#0B1739",
    shadow: "1px 1px 1px 0px rgba(16, 25, 52, 0.40)",
  },
  adminGraderUserCard: {
    background1: "transparent",
    selectedBackground: "#0B1739",
    hover:"#0B1739",
    text1: "#FFF",
    text2: "#AEB9E1",
    text3: "#AEB9E1",
  },
  adminNav: {
    shadow: "none",
    background1: "#150025",
    text1: "#FFF",
    text2: "#AEB9E1",
  },
  adminNavItem: {
    background1: "#081028",
    background2: "7E89AC",
    text1: "#AEB9E1",
    text2: "#FFF",
    text3: "#CB3CFF",
    border2: "#CB3CFF",
  },
  qTab: {
    background1: "#0B1739",
    selectedBackground: "#55555578",
    text1: "white",
    text2: "lightgray",
  },
  border: {
    adminDashBorder: "#10193466",
    adminGraderContainerBorder: "#343B4F",
    adminCourseQuestionReviewCardBorder: "#343B4F",
  },
};

export const qbraidBasePalette: PaletteOptions = {
  primary: {
    main: "#c430f1",
  },
  secondary: {
    main: "#9b12df",
  },
};
export const qusteamBasePalette: PaletteOptions = {
  primary: {
    main: "#4144bb",
  },
  secondary: {
    main: "#1212df",
  },
};
export const queraBasePalette: PaletteOptions = {
  primary: {
    main: "#6437ff",
  },
  secondary: {
    main: "#8c61ff",
  },
};
